import React from 'react';

const NavigatorDetail = () => (
  <svg width="738" height="55" viewBox="0 0 738 55" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 5C0 2.23857 2.23858 0 5 0H733C735.761 0 738 2.23858 738 5V55H0V5Z" fill="#F1F3F6" />
    <rect width="738" height="14.7321" transform="translate(0 40.2681)" fill="white" />
    <path d="M280 40.2679H24C28.4 40.2679 32 36.7321 32 32.4107V14.7321C32 10.4107 35.6 6.875 40 6.875H264C268.4 6.875 272 10.4107 272 14.7321V32.4107C272 36.7321 275.6 40.2679 280 40.2679Z" fill="white" />
    <g clipPath="url(#clip0_203_2244)">
      <path d="M51.9997 17.3335C53.6672 19.1591 54.6149 21.5282 54.6663 24.0002C54.6149 26.4722 53.6672 28.8412 51.9997 30.6668M51.9997 17.3335C50.3322 19.1591 49.3845 21.5282 49.333 24.0002C49.3845 26.4722 50.3322 28.8412 51.9997 30.6668M51.9997 17.3335C48.3178 17.3335 45.333 20.3183 45.333 24.0002C45.333 27.682 48.3178 30.6668 51.9997 30.6668M51.9997 17.3335C55.6815 17.3335 58.6663 20.3183 58.6663 24.0002C58.6663 27.682 55.6815 30.6668 51.9997 30.6668M45.6664 22.0002H58.333M45.6663 26.0002H58.333" stroke="#CDD8DF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_203_2244">
        <rect width="16" height="16" fill="white" transform="translate(44 16)" />
      </clipPath>
    </defs>
  </svg>
);

export default NavigatorDetail;
